<template>
    <SignIn></SignIn>
    <Footer></Footer>
</template>

<script>
  import SignIn from '@/components/user/SignIn.vue'
  import Footer from '@/components/Footer.vue'

import {mapGetters,mapActions} from 'vuex'
  export default {
    components: {
        SignIn,
        Footer
    },
      computed: {
        ...mapGetters([
            'isMobile'
        ]),
    },
  }
</script>

